import { React, useEffect } from "react";
import AOS from "aos";
import goals from "../../images/Industries/goals.png"
import property_matching from "../../images/Industries/property_matching.png"
import site_visit from "../../images/Industries/site_visit.png"
import deal_close from "../../images/Industries/deal_close.png"
import dotted_line from "../../images/Industries/line.png"



function Howitworks() {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);




  const process = [
    {
      icon: goals,
      alt: "goal icon",
      Heading: "Understanding Your Needs",
      content: "We start by capturing every detail of your requirements to create a clear property brief."
    },
    {
      icon: property_matching,
      alt: "Property icon",
      Heading: "Property Matching",
      content: "Using our advanced matching tools, we identify properties that fit your business needs perfectly."
    },
    {
      icon: site_visit,
      alt: "sitevist icon",
      Heading: "Site Visit",
      content: "We organise property visits so you can experience the space and ensure it matches your vision."
    },
    {
      icon: deal_close,
      alt: "dealclose icon",
      Heading: "Deal Closure",
      content: "From negotiations to legal compliance, we secure the right property on the best terms."
    },

  ]




  return (
    <>

      <div className="max-w-[1200px] mx-auto my-[60px] p-2 lg:my-[130px]">

        {/* Heading */}
        <div>
          <h1 className='heading' data-aos="fade-up">Our Process</h1>
          <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" fade-aos-duration="800"/>
        </div>

        <div className="my-[80px] flex flex-wrap justify-around gap-10 relative">
          <img className="w-full absolute top-10 hidden lg:block" src={dotted_line} alt="" data-aos="fade-up"/>
          {
            process.map((items) => {
              return (
                <div className="w-[239px] h-fit text-center space-y-[20px] z-40 mx-auto lg:mx-0" data-aos="fade-up">
                  <img className="w-[89px] mx-auto" src={items.icon} alt={items.alt} />
                  <h1 className="font-noto text-[22px] font-semibold">{items.Heading}</h1>
                  <p className="font-alibaba text-[18px] leading-[25px] text-[#5F5D5E]">{items.content}</p>
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  )
}


export default Howitworks;